import { useEffect, useState } from "react";
import { db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export default function CategoryUpload() {
  const [input, setInput] = useState("");
  const [manualCategory, setManualCategory] = useState("");
  const [manualSub, setManualSub] = useState("");
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const load = async () => {
      const snap = await getDoc(doc(db, "metadata", "categories"));
      if (snap.exists()) {
        setCategories(snap.data().categories || []);
      }
    };
    load();
  }, []);

  const handleUpload = async () => {
    try {
      const parsed = JSON.parse(input);
      const ref = doc(db, "metadata", "categories");
      await setDoc(ref, {
        version: Date.now(),
        updatedAt: new Date(),
        categories: parsed,
      });
      setMessage("✅ Kategorier uppdaterade!");
    } catch (err) {
      setMessage("❌ Fel vid uppladdning: " + err.message);
    }
  };

  const handleManualAdd = async () => {
    const ref = doc(db, "metadata", "categories");
    const snap = await getDoc(ref);
    if (!snap.exists()) return setMessage("❌ Kategoridata saknas");

    const data = snap.data();
    const updated = [...(data.categories || [])];
    const exists = updated.find((cat) => cat.name === manualCategory);

    if (exists) {
      if (manualSub && !exists.subcategories.includes(manualSub)) {
        exists.subcategories.push(manualSub);
      }
    } else {
      updated.push({ name: manualCategory, subcategories: manualSub ? [manualSub] : [] });
    }

    await setDoc(ref, {
      version: Date.now(),
      updatedAt: new Date(),
      categories: updated,
    });
    setMessage("✅ Kategori uppdaterad!");
    setManualCategory("");
    setManualSub("");
  };

  const handleSelect = (e) => {
    setManualCategory(e.target.value);
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Ladda upp kategorilista</h2>
      <textarea
        rows={10}
        cols={60}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Klistra in JSON här"
      />
      <br />
      <button onClick={handleUpload}>Ladda upp</button>

      <h3 style={{ marginTop: 32 }}>Lägg till ny kategori eller underkategori</h3>
      <label>Välj befintlig kategori:</label>
      <select value={manualCategory} onChange={handleSelect}>
        <option value="">-- Välj kategori --</option>
        {categories.map((cat) => (
          <option key={cat.name} value={cat.name}>{cat.name}</option>
        ))}
      </select>
      <br />
      <label>Eller skriv ny kategori:</label>
      <input
        type="text"
        value={manualCategory}
        onChange={(e) => setManualCategory(e.target.value)}
        placeholder="Kategori"
        disabled={manualCategory && categories.find((c) => c.name === manualCategory)}
      />
      <input
        type="text"
        value={manualSub}
        onChange={(e) => setManualSub(e.target.value)}
        placeholder="Underkategori (valfri)"
        style={{ marginLeft: 8 }}
      />
      <br />
      <button onClick={handleManualAdd} style={{ marginTop: 8 }}>Lägg till</button>

      <div style={{ marginTop: 16 }}>{message}</div>
    </div>
  );
}